import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { IonIcon } from '@ionic/react';
import InputAdornment from '@mui/material/InputAdornment';

import StyledTextField from '~config/MaterialUIStyles/TextField';

import styles from './styles.module.scss';

class InputLabel extends Component {
  handleChange = e => {
    const { onChangeFormik, onChange } = this.props;

    onChangeFormik?.(e);
    onChange?.(e);
  };

  render() {
    const {
      actions,
      className,
      icon,
      inputClassName,
      name,
      placeholder,
      inputType,
      onFocus,
      onBlur,
      disabled,
      value,
      readOnly,
      iconClassName,
      sx,
      focused
    } = this.props;
    const inputProps = {
      ...(icon
        ? {
            startAdornment: (
              <InputAdornment position="start">
                <IonIcon
                  size="large"
                  className={`m-right-2 text-emperor ${styles.icon} ${iconClassName}`}
                  icon={icon}
                />
              </InputAdornment>
            )
          }
        : {}),
      ...(actions
        ? {
            endAdornment: <InputAdornment position="end">{actions}</InputAdornment>
          }
        : {})
    };
    return (
      <div
        className={cn('row center text-base', className, {
          [styles.dirty]: value
        })}>
        <StyledTextField
          sx={{ mb: '5px', mt: '5px', ...sx }}
          InputProps={inputProps}
          InputLabelProps={{
            shrink: focused || value?.length > 0,
            sx: { ...(!value && !focused && { ml: '30px' }) }
          }}
          className={`row full-width ${styles.input} ${inputClassName}`}
          name={name}
          id={name}
          type={inputType}
          onChange={this.handleChange}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          value={value}
          readOnly={readOnly}
          autoComplete="off"
          label={placeholder}
        />
      </div>
    );
  }
}

InputLabel.propTypes = {
  inputType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  actions: PropTypes.element,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  sx: PropTypes.shape({
    border: PropTypes.string
  }),
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onChangeFormik: PropTypes.func,
  onFocus: PropTypes.func
};

InputLabel.defaultProps = {
  className: '',
  iconClassName: '',
  inputClassName: '',
  placeholder: '',
  sx: {}
};

export default InputLabel;
